import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Menu, X, ChevronLeft, ChevronRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BrochureForm from "../components/dashboard components/forms/BrochureForm";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const TABS = ["HOME", "GALLERY", "PLAN", "LOCATION", "AMENITIES", "APPROVALS & COMPLIANCES"];

const OngoingProjectPage = () => {
const { slug } = useParams();

const slugify = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");




  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [activeTab, setActiveTab] = useState("HOME");
  const [selectedImage, setSelectedImage] = useState(null);
  const [showBrochureForm, setShowBrochureForm] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pendingDocUrl, setPendingDocUrl] = useState(null);
  const [showSlideshow, setShowSlideshow] = useState(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const toAbsUrl = (url) => {
    if (!url) return null;
    if (/^https?:\/\//i.test(url)) return url;
    const base = (API_BASE_URL || "").replace("/api", "");
    return `${base}${url.startsWith("/") ? url : `/${url}`}`;
  };

  useEffect(() => {
    fetchProjectsList();
  }, []);

useEffect(() => {
  if (!slug || projects.length === 0) return;

  const foundProject = projects.find(
    (p) => slugify(p.project_name) === slug
  );

  if (foundProject) {
    setCurrentProject(foundProject);
    fetchProjectGallery(foundProject.project_id);
  }
}, [slug, projects]);


const fetchProjectsList = async () => {
  try {
    const [ongoingRes, completedRes] = await Promise.all([
      axios.get(`${API_BASE_URL}/projects/ongoing`),
      axios.get(`${API_BASE_URL}/projects/completed-cards`),
    ]);

    const ongoing = Array.isArray(ongoingRes.data) ? ongoingRes.data : [];
    const completed = Array.isArray(completedRes.data) ? completedRes.data : [];

    const list = [...ongoing, ...completed];

    setProjects(list);

    if (list.length > 0 && !slug) {
      setCurrentProject(list[0]);
    }
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
};

  const fetchProjectGallery = async (id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/projects/${id}`);

      if (Array.isArray(res.data) && res.data.length > 0) {
        const gallery = res.data[0];
        const parsedImages = Array.isArray(gallery.gallery_data)
          ? gallery.gallery_data
          : JSON.parse(gallery.gallery_data || "[]");
        const sortedImages = parsedImages.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setCurrentProject((prev) => ({
          ...prev,
          galleryImages: sortedImages,
        }));
      } else {
        setCurrentProject((prev) => ({ ...prev, galleryImages: [] }));
      }
    } catch (error) {
      console.error("❌ Error fetching project gallery:", error);
      setCurrentProject((prev) => ({ ...prev, galleryImages: [] }));
    }
  };

const handleProjectChange = (e) => {
  const newId = e.target.value;

  const selected = projects.find(
    (p) => String(p.project_id) === String(newId)
  );

  if (selected) {
    navigate(`/projects/${slugify(selected.project_name)}`);
  }
};

  const handleBackToProjects = () => navigate("/projects");

  const openLightbox = (image, index) => {
    setCurrentSlideIndex(index);
    setShowSlideshow(true);
  };
  
  const closeLightbox = () => {
    setShowSlideshow(false);
    setCurrentSlideIndex(0);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setIsOpen(false); // close mobile menu on selection
  };

  const nextSlide = () => {
    if (currentProject?.gallery_images) {
      setCurrentSlideIndex((prev) =>
        prev === currentProject.gallery_images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const previousSlide = () => {
    if (currentProject?.gallery_images) {
      setCurrentSlideIndex((prev) =>
        prev === 0 ? currentProject.gallery_images.length - 1 : prev - 1
      );
    }
  };

  if (!currentProject) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <p className="text-gray-500 text-lg">Loading project details...</p>
      </div>
    );
  }

  const title = currentProject.project_name || "Project";
  const status = currentProject.project_status || "Ongoing";
  const description = currentProject.project_description || "";
  const rera = currentProject.project_rera || "";
  const extent = currentProject.project_extent || "";
  const location = currentProject.project_badge_location || "";
  const hmda = currentProject.hmda || "";
  const brochureUrl = currentProject.brochure || null;

  let galleryImages = [];
  try {
    galleryImages = currentProject.gallery
      ? JSON.parse(currentProject.gallery)
      : [];
  } catch {
    galleryImages = [];
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
       {/* ✅ Added padding below header so tabs are not overlapped */}
      <div className="pt-24 sm:pt-28"></div>

      {/* Breadcrumb and Project Selector */}
      <div className="bg-gray-50 py-4 px-4 border-b">
        <div className="container mx-auto max-w-7xl">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex items-center gap-2 text-sm md:text-base">
              <button
                onClick={handleBackToProjects}
                className="text-blue-600 hover:text-blue-700 font-semibold"
              >
                Projects
              </button>
              <span className="text-gray-400">/</span>
              <span className="text-gray-700 font-medium">{title}</span>
            </div>

            <div className="flex items-center gap-3 md:justify-end w-full md:w-auto">
              <button
                onClick={handleBackToProjects}
                className="bg-green-600 text-white px-4 py-3 rounded-md text-normal font-medium hover:bg-green-700 transition"
              >
                Back to Projects
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white border-b sticky top-16 z-40">
        <div className="container mx-auto max-w-7xl px-4">
          {/* Desktop & Tablet Nav */}
          <nav className="hidden sm:flex gap-2">
            {TABS.map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabClick(tab)}
                className={`px-6 py-4 font-semibold text-sm whitespace-nowrap transition-colors ${
                  activeTab === tab
                    ? "bg-green-600 text-white"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                {tab}
              </button>
            ))}
          </nav>

          {/* Mobile Header + Hamburger */}
          <div className="sm:hidden flex items-center justify-between py-2">
            <div className="font-semibold text-sm text-gray-800">
              {activeTab || "HOME"}
            </div>
            <button
              onClick={() => setIsOpen((prev) => !prev)}
              className="p-2 rounded-md border border-gray-200"
            >
              {isOpen ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>

          {/* Mobile Dropdown */}
          {isOpen && (
            <div className="sm:hidden pb-2">
              <nav className="flex flex-col gap-1">
                {TABS.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => handleTabClick(tab)}
                    className={`w-full text-left px-4 py-2 font-semibold text-sm transition-colors ${
                      activeTab === tab
                        ? "bg-green-600 text-white"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </nav>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="py-10 px-4">
        <div className="container mx-auto max-w-7xl">
          {activeTab === "HOME" && (
            <div>
              <div className="mb-10">
                <div className="flex flex-wrap items-center gap-3 mb-4">
                  <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                    {title}
                  </h1>
                  <span
                    className={`${
                      status === "Completed"
                        ? "bg-blue-500"
                        : "bg-green-500"
                    } text-white px-3 py-1 rounded-full text-xs font-bold`}
                  >
                    {status}
                  </span>
                </div>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed max-w-5xl">
                  {description}
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-xl p-5 mb-8">
                <h3 className="text-lg font-bold text-gray-800 mb-4">
                  Project Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {rera && (
                    <div className="flex items-start gap-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <p className="font-semibold text-gray-700 text-sm">
                          RERA
                        </p>
                        <p className="text-gray-600 text-sm">{rera}</p>
                      </div>
                    </div>
                  )}
                  {extent && (
                    <div className="flex items-start gap-2">
                      <svg
                        className="w-4 h-4 text-blue-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <p className="font-semibold text-gray-700 text-sm">
                          Extent
                        </p>
                        <p className="text-gray-600 text-sm">{extent}</p>
                      </div>
                    </div>
                  )}
                  {hmda && (
                    <div className="flex items-start gap-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <p className="font-semibold text-gray-700 text-sm">
                          HMDA
                        </p>
                        <p className="text-gray-600 text-sm">{hmda}</p>
                      </div>
                    </div>
                  )}
                  {location && (
                    <div className="flex items-start gap-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <p className="font-semibold text-gray-700 text-sm">
                          Location
                        </p>
                        <p className="text-gray-600 text-sm">{location}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {brochureUrl && (
                <div className="flex justify-end mb-6">
                  <button
                    onClick={() => setShowBrochureForm(true)}
                    className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 text-sm font-semibold"
                  >
                    DOWNLOAD PROJECT BROCHURE
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          )}

          {activeTab === "GALLERY" && (
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Project Gallery
                </h2>
                <p className="text-gray-600">
                  {currentProject.gallery_description ||
                    "Explore our project through these images"}
                </p>
              </div>

              {currentProject.gallery_images &&
              currentProject.gallery_images.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {currentProject.gallery_images.map((item, index) => (
                    <div
                      key={index}
                      className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer bg-gradient-to-br from-gray-50 to-gray-100"
                      onClick={() => openLightbox(item.image, index)}
                    >
                      <div className="aspect-w-16 aspect-h-12 h-64 flex items-center justify-center p-4">
                        <img
                          src={item.image}
                          alt={item.description || `Gallery ${index + 1}`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      {item.description && (
                        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-3">
                          <p className="text-sm">{item.description}</p>
                          {item.date && (
                            <p className="text-xs text-gray-300 mt-1">
                              {new Date(item.date).toLocaleDateString()}
                            </p>
                          )}
                        </div>
                      )}
                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                        <svg
                          className="w-12 h-12 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                          />
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <svg
                    className="w-20 h-20 mx-auto text-gray-300 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <p className="text-gray-600">
                    No gallery images available yet
                  </p>
                </div>
              )}
            </div>
          )}

          {activeTab === "PLAN" && (
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Floor Plans
                </h2>
                <p className="text-gray-600">
                  View detailed project plans and layouts
                </p>
              </div>

              {currentProject.project_plan_images &&
              currentProject.project_plan_images.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {currentProject.project_plan_images.map(
                    (planImage, index) => (
                      <div
                        key={index}
                        className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer bg-white"
                        onClick={() => setSelectedImage(planImage)}
                      >
                        <div className="p-4">
                          <img
                            src={planImage}
                            alt={`Floor Plan ${index + 1}`}
                            className="w-full h-auto object-contain group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                          <svg
                            className="w-12 h-12 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                            />
                          </svg>
                        </div>
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div className="text-center py-20">
                  <svg
                    className="w-20 h-20 mx-auto text-gray-300 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <p className="text-gray-600">
                    Floor plans will be available soon
                  </p>
                </div>
              )}
            </div>
          )}

          {activeTab === "LOCATION" && (
             <div>
               <div className="mb-8">
                 <h2 className="text-3xl font-bold text-gray-800 mb-2">
                   Location Map
                 </h2>
       
               </div>

               {/* If the project_location URL exists → show embedded Google map */}
               {currentProject.project_location ? (
                 <div className="w-full h-[450px] rounded-xl overflow-hidden shadow-lg">
                   <iframe
                     src={currentProject.project_location}
                     width="100%"
                     height="100%"
                     style={{ border: 0 }}
                     allowFullScreen=""
                     loading="lazy"
                     referrerPolicy="no-referrer-when-downgrade"
                   ></iframe>
                 </div>
               ) : (
                 <div className="text-center py-20">
                   <svg
                     className="w-20 h-20 mx-auto text-gray-300 mb-4"
                     fill="none"
                     stroke="currentColor"
                     viewBox="0 0 24 24"
                   >
                     <path
                       strokeLinecap="round"
                       strokeLinejoin="round"
                       strokeWidth={2}
                       d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 111.314 0z"
                     />
                     <path
                       strokeLinecap="round"
                       strokeLinejoin="round"
                       strokeWidth={2}
                       d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                     />
                   </svg>
                   <p className="text-gray-600">
                     Location map will be available soon
                   </p>
                            </div>
               )}
             </div>
           )}
 
          {activeTab === "AMENITIES" && (
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Amenities
                </h2>
                <p className="text-gray-600">
                  World-class amenities for your comfort
                </p>
              </div>

              {currentProject.project_amenities &&
              currentProject.project_amenities.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {currentProject.project_amenities.map(
                    (amenity, index) => (
                      <div
                        key={index}
                        className="bg-gradient-to-br from-blue-50 to-green-50 rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
                      >
                        <div className="flex items-start gap-4">
                          {amenity.icon ? (
                            <div className="flex-shrink-0 w-12 h-12 bg-blue-500 text-white rounded-full flex items-center justify-center text-xl font-bold">
                              {amenity.icon
                                .charAt(0)
                                .toUpperCase()}
                            </div>
                          ) : (
                            <svg
                              className="w-12 h-12 text-blue-500 flex-shrink-0"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          )}
                          <div className="flex-1">
                            <h3 className="text-lg font-bold text-gray-800 mb-2">
                              {amenity.name}
                            </h3>
                            {amenity.description && (
                              <p className="text-gray-600 text-sm leading-relaxed">
                                {amenity.description}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div className="text-center py-20">
                  <svg
                    className="w-20 h-20 mx-auto text-gray-300 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                  <p className="text-gray-600">
                    Amenities information will be available soon
                  </p>
                </div>
              )}
            </div>
          )}

          {activeTab === "APPROVALS & COMPLIANCES" && (
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Approvals & Compliances
                </h2>
                <p className="text-gray-600">
                  Access all RERA, HMDA and statutory compliance documents for this project.
                </p>
              </div>

              {(() => {
                let approvalDocs = [];
                try {
                  const docs = currentProject.approvals_compliances;
                  if (Array.isArray(docs)) {
                    approvalDocs = docs;
                  } else if (typeof docs === "string" && docs.trim()) {
                    const parsed = JSON.parse(docs);
                    approvalDocs = Array.isArray(parsed) ? parsed : [];
                  }
                } catch (e) {
                  console.error("Error parsing approval documents:", e);
                }

                if (!approvalDocs || approvalDocs.length === 0) {
                  return (
                    <div className="text-center py-20">
                      <svg
                        className="w-20 h-20 mx-auto text-gray-300 mb-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      <p className="text-gray-600">
                        Approval and compliance documents will be available soon.
                      </p>
                    </div>
                  );
                }

                return (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {approvalDocs.map((doc, index) => {
                      const url =
                        typeof doc === "string"
                          ? toAbsUrl(doc)
                          : doc?.url
                          ? toAbsUrl(doc.url)
                          : null;

                      if (!url) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop()
                          : doc.name || doc.label || `Document ${index + 1}`;

                      return (
                        <div
                          key={index}
                          className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
                        >
                          <div className="flex items-center gap-3 mb-3">
                            <svg
                              className="w-8 h-8 text-green-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m2-4H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6z"
                              />
                            </svg>
                            <h3 className="text-lg font-semibold text-gray-800 truncate">
                              {fileName}
                            </h3>
                          </div>
                          <button
                            onClick={() => {
                              setPendingDocUrl(url);
                              setShowBrochureForm(true);
                            }}
                            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 text-sm font-semibold"
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v16h16V8l-6-6H4zm8 5v6m0 0l-3-3m3 3l3-3"
                              />
                            </svg>
                            View / Download PDF
                          </button>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>

     {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300"
            onClick={() => setSelectedImage(null)}
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <img
            src={toAbsUrl(selectedImage)}
            alt="Gallery fullscreen"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {showSlideshow && currentProject.gallery_images && (
        <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex flex-col items-center justify-center p-4">
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
            onClick={closeLightbox}
          >
            <X size={32} />
          </button>

          <button
            className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 z-10 bg-black bg-opacity-50 rounded-full p-2 sm:p-3"
            onClick={previousSlide}
          >
            <ChevronLeft size={24} className="sm:w-8 sm:h-8" />
          </button>

          <div className="w-full max-w-6xl flex flex-col items-center">
            {/* Image Container */}
            <div className="w-full flex items-center justify-center mb-4" style={{ maxHeight: 'calc(100vh - 200px)' }}>
              <img
                src={currentProject.gallery_images[currentSlideIndex]?.image}
                alt={
                  currentProject.gallery_images[currentSlideIndex]?.description ||
                  `Slide ${currentSlideIndex + 1}`
                }
                className="max-w-full max-h-full object-contain"
              />
            </div>

            {/* Description and Date - Always Visible on All Devices */}
            <div className="w-full px-4 sm:px-8 md:px-16">
              {currentProject.gallery_images[currentSlideIndex]?.description && (
                <div className="text-center text-white mb-3">
                  <p className="text-base sm:text-lg md:text-xl font-medium">
                    {currentProject.gallery_images[currentSlideIndex].description}
                  </p>
                </div>
              )}
              
              {currentProject.gallery_images[currentSlideIndex]?.date && (
                <div className="text-center text-gray-300 mb-3">
                  <p className="text-xs sm:text-sm md:text-base">
                    {new Date(
                      currentProject.gallery_images[currentSlideIndex].date
                    ).toLocaleDateString()}
                  </p>
                </div>
              )}

              {/* Image Counter */}
              <div className="text-center text-white">
                <p className="text-xs sm:text-sm md:text-base font-semibold">
                  {currentSlideIndex + 1} / {currentProject.gallery_images.length}
                </p>
              </div>
            </div>
          </div>

          <button
            className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 z-10 bg-black bg-opacity-50 rounded-full p-2 sm:p-3"
            onClick={nextSlide}
          >
            <ChevronRight size={24} className="sm:w-8 sm:h-8" />
          </button>
        </div>
      )}

      {showBrochureForm && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex justify-center items-center p-4">
          <div className="relative bg-white rounded-xl shadow-2xl max-w-md w-full p-6 sm:p-8">
            <button
              onClick={() => setShowBrochureForm(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            
            <BrochureForm
              onSuccess={() => {
                setShowBrochureForm(false);
                if (pendingDocUrl) {
                  window.open(pendingDocUrl, "_blank");
                  setPendingDocUrl(null);
                } else if (brochureUrl) {
                  window.open(brochureUrl, "_blank");
                }
              }}
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default OngoingProjectPage;
